module.exports = __webpack_public_path__ + "static/dc-a160e88f943eb05701be9ca29ed05217.png";